import { RenditionsService } from '@alfresco/adf-core';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { AldenService } from '../services/alden.service';

@Pipe({ name: 'rendition' })
export class RenditionPipe implements PipeTransform {

  private readonly IMGPREVIEW_ENCODING: string = "imgpreview";

  subscriptions: Subscription[];

  constructor(private renditionsService: RenditionsService, private aldenService: AldenService) {
    this.subscriptions = [];
  }

  transform(nodeId: string) {
    return new Observable<string>((subscriber) => {
      this.subscriptions.push(this.renditionsService.isRenditionAvailable(nodeId, this.IMGPREVIEW_ENCODING).subscribe({
            next: (isAvailable) => {
              if (isAvailable) {
                this.returnRenditionBase64(nodeId, subscriber);
              } else {
                this.subscriptions.push(this.renditionsService.createRendition(nodeId, this.IMGPREVIEW_ENCODING).subscribe({
                      next: () => {
                        this.returnRenditionBase64(nodeId, subscriber);
                      },
                      error: () => {
                        this.returnRenditionNotAvailable(subscriber);
                      }
                    })
                );
              }
            },
            error: () => {
              this.returnRenditionNotAvailable(subscriber);
            }
          })
      );
    });
  }
  
  private returnRenditionNotAvailable(subscriber: Subscriber<string>) {
    subscriber.next();
    subscriber.complete();
    this.unsuscribe();
  }

  private returnRenditionBase64(nodeId: string, subscriber: Subscriber<string>) {
    this.getRenditionContent(nodeId).then((blob) => {
        if (!blob) return null;
        return this.convertBlobToBase64(blob);
      }).then((rendition) => {
        subscriber.next(rendition);
        subscriber.complete();
        this.unsuscribe();
      }).catch(() => {
        this.returnRenditionNotAvailable(subscriber);
      });
  }

  private convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader: FileReader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data: string = reader.result as string;
        resolve(base64data);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  private getRenditionContent(nodeId: string) {
    const path = `nodes/${nodeId}/renditions/${this.IMGPREVIEW_ENCODING}/content?attachment=false`;
    const httpMethod = 'GET';
    const responseType = 'blob';
    return this.aldenService
      .callAlfrescoCoreApi(
        path,
        httpMethod,
        {},
        {},
        {},
        {},
        [],
        [],
        responseType,
      );
  }

  private unsuscribe() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }
  
}